import React, { useState } from "react";
import "./leadpage.scss";
import fitojaLogo from "../assets/fitoja-logo.png";

const App = () => {
  return <LeadPageGoogle />;
};

const LeadPageGoogle = () => {
  // State to manage form data
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    goal: "",
    phone: "",
  });

  // State to manage UI feedback during and after form submission
  const [loading, setLoading] = useState(false);

  // Handles changes to form inputs
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handles form submission to the API
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Map formData keys to the API's required keys
    const apiData = {
      fullName: formData.name,
      phoneNumber: formData.phone,
      age: formData.age,
      goal: formData.goal,
    };

    try {
      const response = await fetch('https://api.fitoja.in/api/submit-lead-form-google', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiData),
      });

      const result = await response.json(); // Parse the JSON response

      if (response.ok) {
        // Optional: clear the form after successful submission
        setFormData({
          name: "",
          age: "",
          goal: "",
          phone: "",
        });
        const whatsappMessage = `Hi, I submitted my details on Fitoja via Google Ads:\nName: ${formData.name}\nAge: ${formData.age}\nGoal: ${formData.goal}`;
        const url = `https://wa.me/919891113123?text=${encodeURIComponent(
          whatsappMessage
        )}`;
        window.open(url, "_blank");
      } else {
      }
    } catch (error) {
      // Handle network errors (e.g., no internet connection)
      console.error('Error submitting form:', error);
    } finally {
      setLoading(false); // End loading state
    }
  };

  return (
    <div className="lead-page">
      <div className="lead-container">
      <div className="lead-left">
          <img src={fitojaLogo} alt="Fitoja Logo" className="logo" />
          <h1>Get Your Custom Diet Plan</h1>
          <p>India’s Smartest Way to Lose Weight.</p>
        </div>
        <div className="lead-right">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="number"
              name="age"
              placeholder="Your Age"
              value={formData.age}
              onChange={handleChange}
              required
            />

            <select
              name="goal"
              value={formData.goal}
              onChange={handleChange}
              required
            >
              <option value="">Select Goal</option>
              <option value="Weight Loss">Weight Loss</option>
              <option value="Weight Gain">Weight Gain</option>
              <option value="Muscle Gain">Muscle Gain</option>
            </select>
            <input
              type="tel"
              name="phone"
              placeholder="WhatsApp Number"
              value={formData.phone}
              onChange={handleChange}
              pattern="[0-9]{10}"
              maxLength={10}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Get Plan on WhatsApp"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default App;
